<template>
  <a :href="platform === 'apple' ? `https://apps.apple.com/fr/app/vibes-lgbt-rencontre-sors/id6463439764` : `https://play.google.com/store/apps/details?id=lgbt.vibes.app`" class="p-3 bg-royal-100 dark:bg-royal-400/30 text-royal-950 dark:text-royal-200 rounded-2xl flex items-center text-left" v-if="!isNative">
    <div class="shrink-0">
      <AppAnimatedIcon class="w-16 h-16" />
    </div>

    <div class="grow pl-3">
      <p class="font-bold text-md">{{ $t('components.AppDownload.title') }}</p>
      <p class="text-xs leading-tight font-medium mt-0.5">{{ $t('components.AppDownload.content') }}</p>
    </div>

    <div class="shrink-0 pl-3 space-x-2" v-if="!isNative">
      <ButtonBase class="hidden md:inline-flex" style-type="round" href="https://apps.apple.com/fr/app/vibes-lgbt-rencontre-sors/id6463439764" size="sm" color="white">
        <IconBase name="apple" :width="16" class="-mt-0.5" />
      </ButtonBase>
      <ButtonBase class="hidden md:inline-flex" style-type="round" href="https://play.google.com/store/apps/details?id=lgbt.vibes.app" size="sm" color="white">
        <IconBase name="android" :width="20" class="-mt-0.5" />
      </ButtonBase>
      <ButtonBase style-type="round" size="sm" color="white" @click.native.prevent.stop="emit('close')" v-if="isClosable">
        <IconBase name="cute/cross" :width="18" />
      </ButtonBase>
    </div>
  </a>
</template>

<script lang="ts" setup>
import { getDeviceInfo } from '@/utils/native/useDevice'

defineProps<{
  isClosable?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const isNative = ref(true)
const platform = ref('android')

onMounted(async () => {
  const deviceInfo = await getDeviceInfo()
  if (deviceInfo) {
    isNative.value = deviceInfo.platform === 'ios' || deviceInfo.platform === 'android'
    platform.value = deviceInfo?.operatingSystem === 'mac' || deviceInfo?.operatingSystem === 'ios' ? 'apple' : 'android'
  }
})
</script>